import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import * as ko from "knockout";
import * as $ from "jquery";
class UnitChargenreportTabViewModel extends GenericListSearchTab {
    constructor(tabPage, parent) {
        super(tabPage, parent);
        this.SearchConfig.CustomFilter = { SessionTabId: this.SessionTabId, DistinctSessionObjects: true };
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
    SearchType(): string {
        return "Area";
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
}
export default UnitChargenreportTabViewModel;